module.exports = __webpack_public_path__ + "assets/images/premium-locked-screen/tag/header-e624b8.png";